// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import scrubPathSummary from 'components/PathSummary/prepData/scrubPathSummary'
import { fetchPathSummaryById } from 'helpers/api'
import { warning } from 'react-notification-system-redux'
import { UNCAUGHT_ERROR } from 'errors'

import {
  filterAndSortPathIds,
  updatePaths,
} from 'redux/modules/projectSummary'

const addPathToProjectSummary = pathId => async (dispatch, getState) => {
  const { projectSummary } = getState()
  const storedPaths = projectSummary.get('paths')
  const unitType = projectSummary.get('unitType')

  // this becomes a stored value in redux state
  const pathIndex = storedPaths.size

  try {
    const { entity } = await fetchPathSummaryById(pathId)
    const scrubbedPathSummary = scrubPathSummary(entity, pathIndex, unitType)

    const paths = storedPaths.push(fromJS(scrubbedPathSummary))
    dispatch(updatePaths(paths))
    // triggers an update to the visible paths in project summary.
    dispatch(filterAndSortPathIds())
  } catch (err) {
    console.warn(err)
    dispatch(warning({
      autoDismiss: 3,
      message: `Error adding Path Summary to Project Summary - ${err.message || UNCAUGHT_ERROR}`,
    }))
  }
}

export default addPathToProjectSummary
